"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfReportProcessingOutput = instanceOfReportProcessingOutput;
exports.ReportProcessingOutputFromJSON = ReportProcessingOutputFromJSON;
exports.ReportProcessingOutputFromJSONTyped = ReportProcessingOutputFromJSONTyped;
exports.ReportProcessingOutputToJSON = ReportProcessingOutputToJSON;
var Metadata_1 = require("./Metadata");
var ReportProcessing_1 = require("./ReportProcessing");
/**
 * Check if a given object implements the ReportProcessingOutput interface.
 */
function instanceOfReportProcessingOutput(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function ReportProcessingOutputFromJSON(json) {
    return ReportProcessingOutputFromJSONTyped(json, false);
}
function ReportProcessingOutputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(ReportProcessing_1.ReportProcessingFromJSON)),
        'metadata': json['metadata'] == null ? undefined : (0, Metadata_1.MetadataFromJSON)(json['metadata']),
    };
}
function ReportProcessingOutputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(ReportProcessing_1.ReportProcessingToJSON)),
        'metadata': (0, Metadata_1.MetadataToJSON)(value['metadata']),
    };
}
